import { configureStore, combineReducers } from "@reduxjs/toolkit";
import user from "./reducers/user";
import modal from "./reducers/modal";
import currentService from "./reducers/currentService";
import transactionDetails from "./reducers/transactionDetails";
import storage from 'redux-persist/lib/storage'
import {
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
} from 'redux-persist'
import bills from "./reducers/bills";

const allReducers = combineReducers({
    user,
    modal,
    currentService,
    transactionDetails,
    bills
})
const persistConfig = {
    key: 'lasgExamBoard',
    storage,
    blacklist: ['modal']
}
const persistedReducer = persistReducer(persistConfig, allReducers)
export default configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
                // Ignore the modal state path which contains React elements
                ignoredPaths: ['modal.content'],
            },
        }),
});